import { queryClient } from '@routable/shared';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { startIsSubmitting, endIsSubmitting } from 'ducks/itemSplitBill';
import { confirmAlert } from 'helpers/confirmAlert';
import errorAlert from 'helpers/errorAlert';
import { postItemSplitBill } from './requests';
export const useSplitBill = ({ attachments, errorCallback, itemId, selectedAttachment, successCallback }) => {
    const dispatch = useDispatch();
    const selectedAttachmentId = selectedAttachment?.id;
    const isSplitBillDisabled = Boolean(selectedAttachment?.primary || attachments.length <= 1);
    const onSplitBill = useCallback(async () => {
        const confirmSubmit = await confirmAlert('This attachment will be removed from the original bill and used to create a new one.', 'Create new bill from attachment', {
            buttonsConfig: {
                confirmButtonText: 'Confirm',
            },
        });
        if (!confirmSubmit) {
            return;
        }
        dispatch(startIsSubmitting());
        try {
            const response = await postItemSplitBill(itemId, selectedAttachmentId);
            if (!response.ok) {
                await errorAlert(`Something went wrong trying to split the bill.`, response.headers['request-id'], undefined, {
                    buttonsConfig: {
                        confirmButtonText: 'Confirm',
                        showCancel: false,
                    },
                });
            }
            else if (response.status === 201) {
                queryClient.refetchQueries({ queryKey: ['items', 'by-id', itemId] });
                successCallback(response.data);
            }
            else if (response.status === 202) {
                errorCallback();
            }
        }
        finally {
            dispatch(endIsSubmitting());
        }
    }, [dispatch, errorCallback, itemId, selectedAttachmentId, successCallback]);
    return {
        onSplitBill,
        isSplitBillDisabled,
    };
};
